module.exports = __webpack_public_path__ + "static/media/3-xs.a1e1d8ed.jpg";